import { render } from "./Entrance.vue?vue&type=template&id=2b806d86&scoped=true"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"

import "./Entrance.vue?vue&type=style&index=0&id=2b806d86&scoped=true&lang=css"
import "./Entrance.vue?vue&type=style&index=1&id=2b806d86&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b806d86"]])

export default __exports__